import { Injectable, ElementRef } from '@angular/core';
import { Portal } from '@angular/cdk/portal';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ToolbarService {
  get toolbarLeftPortal$() {
    return this.toolbarLeftPortalSubject.asObservable();
  }

  get toolbarCenterPortal$() {
    return this.toolbarCenterPortalSubject.asObservable();
  }

  private toolbarLeftPortalSubject: BehaviorSubject<any>;
  private toolbarCenterPortalSubject: BehaviorSubject<any>;

  private _toolbarElement: ElementRef | null = null;

  getToolbarRef(): ElementRef | null {
    return this._toolbarElement;
  }

  setToolbarRef(element: ElementRef) {
    this._toolbarElement = element;
  }

  setLeftPortal(portal: Portal<any>) {
    this.toolbarLeftPortalSubject.next(portal);
  }

  setCenterPortal(portal: Portal<any>) {
    this.toolbarCenterPortalSubject.next(portal);
  }

  constructor() {
    this.toolbarLeftPortalSubject = new BehaviorSubject(null);
    this.toolbarCenterPortalSubject = new BehaviorSubject(null);
  }
}
